import { Checkbox } from "@/components/ui/checkbox";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { fmtIDR } from "@/lib/api";
import { fmtDate } from "@/components/DateInput";
import { Search } from "lucide-react";
import { termLabel } from "@/components/invoice/invoiceUtils";

function TermInfo({ info }) {
  return (
    <div className="rounded bg-secondary/40 p-2 text-xs space-y-1" data-testid="inv-term-info">
      <div className="flex justify-between font-medium"><span>Nilai kontrak (DPP)</span><span className="num">{fmtIDR(info.contract_dpp)}</span></div>
      {info.terms.map((t) => (
        <div key={t.id} className="flex justify-between text-muted-foreground gap-3">
          <span>{termLabel(t)} · {t.invoice_no} · {fmtDate(t.date)}</span><span className="num">{fmtIDR(t.dpp)}</span>
        </div>
      ))}
      <div className="flex justify-between font-semibold border-t border-border pt-1"><span>Sisa kontrak</span><span className="num" data-testid="inv-term-remaining">{fmtIDR(info.remaining)}</span></div>
      {info.has_pelunasan && <p className="text-rose-600">Kontrak ini sudah memiliki invoice pelunasan.</p>}
    </div>
  );
}

export function InvoiceTermBox({ f, setF, info, onLookup }) {
  const isDp = f.invoice_type === "dp";
  const isLunas = f.invoice_type === "pelunasan";
  const setType = (typ, on) => setF((s) => ({ ...s, invoice_type: on ? typ : "tunai" }));
  return (
    <div className="rounded-md border border-border p-3 space-y-3" data-testid="inv-term-box">
      <div className="flex items-center gap-x-5 gap-y-2 flex-wrap">
        <span className="text-sm font-medium">Jenis Invoice</span>
        <label className="flex items-center gap-2 text-sm cursor-pointer"><Checkbox checked={isDp} onCheckedChange={(v) => setType("dp", !!v)} data-testid="inv-type-dp" />DP / Termin</label>
        <label className="flex items-center gap-2 text-sm cursor-pointer"><Checkbox checked={isLunas} onCheckedChange={(v) => setType("pelunasan", !!v)} data-testid="inv-type-pelunasan" />Pelunasan</label>
        <span className="text-xs text-muted-foreground" data-testid="inv-type-label">
          {isDp ? "DPP pajak = nominal DP / termin" : isLunas ? "DPP pajak = sisa nilai kontrak" : "Tunai — tanpa centang, pajak normal dari DPP"}
        </span>
      </div>
      {(isDp || isLunas) && (
        <div className="grid sm:grid-cols-2 gap-3">
          <div className="space-y-1.5">
            <Label className="text-xs">No. Invoice DP Pertama {isDp && <span className="text-muted-foreground font-normal">(kosongkan untuk Termin 1)</span>}</Label>
            <div className="flex gap-2">
              <Input value={f.ref_invoice_no} onChange={(e) => setF((s) => ({ ...s, ref_invoice_no: e.target.value }))} onBlur={onLookup} placeholder="INV/..." data-testid="inv-ref-no" />
              <Button type="button" variant="outline" size="sm" className="h-9 shrink-0" onClick={onLookup} disabled={!f.ref_invoice_no} data-testid="inv-ref-lookup"><Search className="h-4 w-4 mr-1" />Ambil Data</Button>
            </div>
          </div>
          {isDp && (
            <div className="space-y-1.5"><Label className="text-xs">Nominal DP / Termin (DPP)</Label>
              <Input type="number" className="num" value={f.dp_amount} onChange={(e) => setF((s) => ({ ...s, dp_amount: e.target.value }))} data-testid="inv-dp-amount" /></div>
          )}
        </div>
      )}
      {isLunas && !info && <p className="text-xs text-amber-600">Isi nomor invoice DP pertama lalu klik "Ambil Data" — nominal pelunasan dihitung otomatis.</p>}
      {info && (isDp || isLunas) && f.ref_invoice_no && <TermInfo info={info} />}
    </div>
  );
}
